import { cleanNumber, formatNumber, isValidNumber } from '@gripp/shared-logic';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { Colors } from '../../../themes';
import { MaskedNumberInput } from '../../forms';
import { CounterExecutionComponentProps } from './counterExecutionComponent';
import { CounterSummary } from './counterSummary';

export const GenericCounterExecutionComponent = (
  props: CounterExecutionComponentProps
) => {
  const { t } = useTranslation();

  const [inputValue, setInputValue] = useState<string>(
    props.value != null && !Number.isNaN(props.value)
      ? props.value.toString()
      : ''
  );

  const change = (raw: string) => {
    if (raw === '') {
      setInputValue('');
      props.onChange(NaN as any);
      return;
    }
    const input = cleanNumber(raw, props.decimalPlaces, true);
    setInputValue(input);
    if (isValidNumber(input)) {
      const num = parseFloat(input);
      props.onChange(num);
    } else {
      props.onChange(NaN as any);
    }
  };

  const initialValueLabel = t(
    'routines.counter.user.genericCounter.initialValue'
  );

  const getDeltaValueLabel = () =>
    t('routines.counter.user.genericCounter.change');

  const getDeltaValue = () => {
    if (
      props.value === undefined ||
      props.value === null ||
      inputValue === ''
    ) {
      return '--';
    }

    return String(
      formatNumber(
        (props.value as number) - props.initialValue,
        props.decimalPlaces ?? 0
      )
    );
  };

  const getNewValueLabel = () =>
    t('routines.counter.user.genericCounter.newValue');

  const getNewValue = () => {
    if (
      inputValue === '' ||
      props.value === undefined ||
      props.value === null ||
      Number.isNaN(props.value)
    )
      return '--';
    return formatNumber(props?.value, props.decimalPlaces ?? 0, true);
  };

  return (
    <View
      style={props.containerStyle ? props.containerStyle : styles.container}
    >
      {props.instructions?.trim() !== '' && (
        <Text style={styles.sectionTitle}>{props.instructions}</Text>
      )}
      <View style={[styles.inputContainer, props?.inputContainerStyle]}>
        <MaskedNumberInput
          value={inputValue}
          decimalPlaces={props.decimalPlaces}
          autoFocus={props.autoFocus}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
          onChangeText={(val) => change(`${val}`)}
          selectionColor={Colors.grayText}
          cursorColor={Colors.grayText}
          outlineStyle={styles.inputOutline}
          contentStyle={styles.inputBody}
          style={{ flex: 1 }}
          showStepper
        />
      </View>
      <CounterSummary
        initialValueLabel={initialValueLabel}
        initialValue={formatNumber(
          props.initialValue,
          props.decimalPlaces,
          true
        )}
        getDeltaValueLabel={getDeltaValueLabel}
        getDeltaValue={getDeltaValue}
        getNewValueLabel={getNewValueLabel}
        getNewValue={getNewValue}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.brand.white,
    borderRadius: 4,
  },
  // sectionTitle: {
  //   fontSize: 16,
  //   fontWeight: '600',
  //   color: Colors.blackText,
  //   letterSpacing: -0.25,
  // },
  inputContainer: {
    width: '100%',
    height: 48,
    marginTop: 20,
    flexDirection: 'row',
    borderRadius: 4,
    overflow: 'hidden',
  },
  inputOutline: {
    borderWidth: 0,
  },
  inputBody: {
    alignItems: 'center',
    backgroundColor: Colors.brand.white,
    color: Colors.blackText,
    borderRadius: 0,
    padding: 20,
    fontSize: 24,
    fontWeight: '500',
    lineHeight: 28.8,
    textAlign: 'center',
  },
  counterButton: {
    width: 48,
    height: '100%',
    backgroundColor: Colors.brand.white,
    borderRadius: 0,
    borderWidth: 0,
    margin: 0,
  },
});
